import { TransportManager } from '@atlas/transport';
import { useEffect } from 'react';

const getProtocol = () => {
  return location.protocol.includes('https') ? 'wss' : 'ws';
};

const initTransport = (
  transport: TransportManager,
  projectId: string,
  devMode: boolean,
) => {
  const notifierUrl = new URL('/ws/notifier2', location.origin);
  notifierUrl.protocol = getProtocol();
  notifierUrl.searchParams.set('projectId', projectId);

  if (devMode) {
    notifierUrl.searchParams.set('project-team-frontend-team', 'x');
  }

  transport.setOptions({ projectId });
  transport.initialize(notifierUrl.toString());
};

const useTransport = (locale: string, projectId: string, devMode = true) => {
  const transport = TransportManager.getInstance();

  useEffect(() => {
    initTransport(transport, projectId, devMode);
  }, [projectId, transport, devMode]);

  useEffect(() => {
    transport.setOptions({ locale });
    transport.resubscribeAll();
  }, [locale, transport]);
};

export default useTransport;
